export default {
  title: 'So funktionieren Verarbeitungsgebühren',
  how_it_works:
    'Stripe berechnet Ihrer Plattform bei jeder Online-Zahlung Ihrer Restaurants seine Gebühr. Die von Ihnen festgelegte Verarbeitungsgebühr zahlt das Restaurant für diese Zahlung. Liegt sie über der Stripe-Gebühr, behalten Sie die Differenz als Marge. Liegt sie darunter oder legen Sie keine fest, zahlen Sie die Differenz selbst.',
  stripe_rates_link: 'Standardpreise von Stripe ansehen',
  example: {
    intro:
      'Beispiel: eine Bestellung über {{total}}, mit Karte bezahlt. Stripe berechnet Ihrer Plattform {{stripe_fee}} ({{stripe_rate}}).',
    above: 'Ihr Satz {{rate}}: Das Restaurant zahlt {{fee}}, Sie behalten {{difference}}.',
    below: 'Ihr Satz {{rate}}: Das Restaurant zahlt {{fee}}, Sie zahlen die Differenz von {{difference}}.',
    none: 'Kein Satz (0 % Marge): Das Restaurant zahlt nichts, Sie zahlen die vollen {{stripe_fee}}.',
    disclaimer:
      'Die Stripe-Gebühr ist hier der Standard-Kartenpreis im EWR, zur Veranschaulichung. Ihre tatsächliche Gebühr hängt von der Karte, ihrem Land und Ihren Stripe-Konditionen ab.',
  },
};
